import CreditCalculator from 'components/home/CreditCalculator';
import { Fragment } from 'react';
import FullPageSpinner from 'components/common/FullPageSpinner';
import { Helmet } from 'react-helmet';
import useTranslation from 'hooks/use-translation';

export default function Home(): JSX.Element {
  const translation = useTranslation();
  if (!translation) {
    return <FullPageSpinner />;
  }

  return (
    <Fragment>
      <Helmet>
        <title>{`Start Your Credit Search - ${translation.appName}`}</title>
      </Helmet>
      <CreditCalculator />
    </Fragment>
  );
}
